import { BigNumber } from 'ethers';
import * as plugins from '../../../Fct/pluginsExport';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var MultiBalance = createMulticallPlugin({
    plugin: plugins.ERC20.getters.BalanceOf,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiBalance',
    name: 'multiBalance',
    config: {
        params: [
            { key: 'to', multicallKey: 'token', isPreview: true },
            { key: 'methodParams.owner', multicallKey: 'account' },
        ],
    },
    estimateGasFromPlugins: function (plugins, chainId) {
        // Gas notes:
        // 1 balance fetch - 7k
        var gas = BigNumber.from(plugins.length).mul(7000);
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
    withPluginOutputs: true,
});
